import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import trans from 'translate';
import { connect } from 'react-redux';
import { normalLogin } from '../../../redux/actions/walletActions';
import './WalletLauncher.scss';

function WalletLauncher({ account, children, normalLogin, action, className, walletConnecting, disabled }) {
  return (
    <>
      {!account && !walletConnecting && !disabled ? (
        <div
          className={clsx('w-100 connect-wallet-to-wrapper', className)}
          onClick={() => normalLogin()}
          style={{ height: '40px' }}
        >
          {trans('common.connect_wallet_to', { action: trans(action, null, false, false) })}
        </div>
      ) : (
        <>{children}</>
      )}
    </>
  );
}

WalletLauncher.defaultProps = {
  children: <></>,
  account: '',
  className: '',
  disabled: false,
  action: '',
};

WalletLauncher.propTypes = {
  children: PropTypes.node,
  account: PropTypes.string,
  normalLogin: PropTypes.func.isRequired,
  action: PropTypes.string,
  className: PropTypes.string,
  walletConnecting: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
};

const mapStateToProps = ({ wallet }) => ({
  account: wallet.account,
  walletConnecting: wallet.connectingWalletProvider || wallet.connectingWallet,
});

const mapDispatchToProps = {
  normalLogin,
};

export default connect(mapStateToProps, mapDispatchToProps)(WalletLauncher);
